import React from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import Home from "./views/home";
import UserContext from "./UserContext"; 

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserContext>
      <App />
    </UserContext>
  </React.StrictMode>
);

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Home />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        hideProgressBar={false}
        newestOnTop
        theme="colored"
      />
    </div>
  );
}

export default App;
